<template>
  <section>
    <hlx-modal
      :key="updateModalKey"
      :modal="true"
      :height="'480px'"
      :modal-active="modal_active"
      :width="'600px'"
      @close="modal_active=false"
    >
      <template v-slot:header>
        <div>Signature Pad</div>
      </template>
      <template v-slot:content>
        <div class="modal-content">
          <section class="signature-pad-heading">
            <span
              :style="{
                backgroundColor: isDrawSignature ? '#54BD95' : '',
                color: isDrawSignature ? 'white' : 'black',
                borderTopLeftRadius: isDrawSignature ? '4px' : '',
                borderBottomLeftRadius: isDrawSignature ? '4px' : '',
              }"
              @click="switchSignature('draw')"
              >Draw</span
            >
            <span
              :style="{
                backgroundColor: isTypeSignature ? '#54BD95' : '',
                color: isTypeSignature ? 'white' : 'black',
              }"
              @click="switchSignature('type')"
              >Type</span
            >
            <span
              :style="{
                backgroundColor: isUploadSignature ? '#54BD95' : '',
                color: isUploadSignature ? 'white' : 'black',
              }"
              @click="switchSignature('upload')"
              >Upload</span
            >
            <span
              :style="{
                backgroundColor: isSavedSignature ? '#54BD95' : '',
                color: isSavedSignature ? 'white' : 'black',
                borderTopRightRadius: isSavedSignature ? '4px' : '',
                borderBottomRightRadius: isSavedSignature ? '4px' : '',
              }"
              @click="switchSignature('saved')"
              >Saved signature</span
            >
          </section>
          <section v-if="isDrawSignature" style="border: 1px solid #d4d4d4">
            <section style="display: flex; justify-content: center">
              <canvas
                :id="'signatureCanvas' + unique"
                padding="12"
                width="540"
                height="258"
                @mousedown="startDrawing"
                @mouseup="stopDrawing"
                @mousemove="draw"
              ></canvas>
            </section>
          </section>
          <section v-if="isTypeSignature">
            <hlx-signature
              :input-val="''"
              @typed-signature-font="getSignatureFont"
              @typed-signature="getSignature"
            ></hlx-signature>
          </section>
          <section class="overwrite-fileupload-height" v-if="isUploadSignature">
            <hlx-file-upload
              :file-type="'.jpg,.jpeg,.png'"
              :file-size-limit="'20mb'"
              :custom-icon="icon"
              :uploadtype="'Rectangle'"
              :type="'upc-regular'"
              :icon="'icon-angle-left-filled'"
              :content="'Import'"
              @fileData="profiledata"
            />
            <!-- <hlx-file-upload
              :file-type="'.jpg,.jpeg,.png'"
              :file-size-limit="'20mb'"
              :uploadtype="'Rectangle'"
              :style-background="backgrounStyleupload"
              :height="50"
              :width="50"
              :read-only="false"
              :custom-icon="icon"
              :type="'profile-upload'"
              :name-display="nameDisplay"
              :profile-icon="'icon-angle-left-filled'"
              :content="'Import'"
              :profile-pic-preview="'data:image/png;base64,PD94bWwgdmVyc2lvbj0nMS4wJyBlbmNvZGluZz0nVVRGLTgnPz48RXJyb3I+PENvZGU+Tm9TdWNoS2V5PC9Db2RlPjxNZXNzYWdlPlRoZSBzcGVjaWZpZWQga2V5IGRvZXMgbm90IGV4aXN0LjwvTWVzc2FnZT48RGV0YWlscz5ObyBzdWNoIG9iamVjdDogc3RvcmFnZWhhbGxleXgvdW5kZWZpbmVkPC9EZXRhaWxzPjwvRXJyb3I+'"
              @fileData="profiledata"
            /> -->
          </section>
        </div>
      </template>
      <template v-slot:footer>
        <section
          :style="{
            justifyContent: !isSavedSignature ? 'space-between ' : 'flex-end',
            width: '100%',
            display: 'flex',
          }"
        >
          <section v-if="!isSavedSignature">
            <hlx-input
              :checked="false"
              :type="'single-checkbox'"
              :label-value="'Save signature'"
            />
          </section>
          <section v-if="isTypeSignature">
            <span style="margin-right: 12px">
              <hlx-button class="secondary sm">Clear</hlx-button>
            </span>
            <hlx-button class="primary sm" @click="emitSignature"
              >Sign</hlx-button
            >
          </section>
          <section v-if="isDrawSignature">
            <span style="margin-right: 12px">
              <hlx-button @click="clearSignatureCanvas" class="secondary sm">Clear</hlx-button>
            </span>
            <hlx-button class="primary sm" @click="getSignatureCanvas"
              >Sign</hlx-button
            >
          </section>
          <section v-if="isUploadSignature">
            <span style="margin-right: 12px">
              <hlx-button class="secondary sm">Clear</hlx-button>
            </span>
            <hlx-button class="primary sm" @click="emitSignatureImage"
              >Sign</hlx-button
            >
          </section>
          <section v-if="isSavedSignature">
            <span style="margin-right: 12px">
              <hlx-button class="secondary sm">Clear</hlx-button>
            </span>
            <hlx-button class="primary sm" @click="emitSignature"
              >Sign</hlx-button
            >
          </section>
        </section>
      </template>
    </hlx-modal>
  </section>
</template>

<script>
import HlxInput from "../components/InputComponent.vue";
import hlxFileUpload from "../components/FileUploadComponent.vue";
// import divider from "../components/DividerComponent.vue";
import hlxModal from "../components/ModalwindowComponent.vue";
// import DrawSignature from "./DrawSignature.vue";
import HlxSignature from "../components/SignatureComponent.vue";
import hlxButton from "../components/ButtonComponent.vue";
// import CodeEditor from "simple-code-editor";
// import hlxTable from "../components/table/HlxTable.vue";
// import hlxTableHead from "../components/table/HlxTableHead.vue";
// import hlxTableCell from "../components/table/HlxTableCell.vue";
// import hlxCascader from "../components/CascaderNewComponent.vue";
export default {
  components: {
    hlxModal,
    // DrawSignature,
    // divider,
    hlxButton,
    HlxInput,
    HlxSignature,
    hlxFileUpload,
    // CodeEditor,
    // hlxTableCell,
    // hlxTableHead,
    // hlxTable,
    // hlxCascader
  },
  props: {
    signatureImageToBase: {
      type: String,
      default: "",
    },
    showSignaturePad:{
      type:Boolean,
      default:false
    }
  },
  emits: [
    "signature-image",
    "emit-signature",
    "close-signature",
    "signature-data-canvas",
    "emit-signature-font",
  ],
  data() {
    return {
      updateModalKey: 0,
      typedSignatureName: "",
      typedSignatureFont: "",
      isDrawSignature: true,
      modal_active: false,
      isTypeSignature: false,
      isUploadSignature: false,
      isSavedSignature: false,
      signatureImageName: "",
      duplicateSignatureDataCanvas: null,
      signatureDataCanvas:null,
    };
  },
  watch: {
    signatureImageName: {
      handler(val) {
        this.signatureImageName = val;
        // this.previewSignatureImage(val)
      },
      immediate: true,
      deep: true,
    },
    showSignaturePad:{
      handler(val) {
        console.log("showSignaturePad watch",val)
        this.modal_active = val;
      },
      immediate: true,
      deep: true,
    }
  },
  mounted() {
    this.updateModalKey++;
  },
  methods: {
    emitSignatureImage() {
      this.modal_active = false;
      this.$emit("signature-image", this.signatureImageName);
    },
    // previewSignatureImage(val){

    // },
    profiledata(val) {
      this.typedSignatureFont = val;
      console.log(val, "signature image");
      this.signatureImageName = val;
    },
    getSignatureFont(val) {
      this.typedSignatureFont = val;
      console.log(val);
    },
    getSignature(val) {
      this.typedSignatureName = val;
      console.log(val);
    },
    getSignedSignature(val) {
      this.$emit("emit-signature", val);
    },
    getSignatureCanvas() {
      this.modal_active = false;
      const canvas = document.getElementById("signatureCanvas" + this.unique);
      const dataURL = canvas.toDataURL();
      this.duplicateSignatureDataCanvas = JSON.parse(JSON.stringify(dataURL));
      this.signatureDataCanvas = JSON.parse(JSON.stringify(dataURL));

      this.$emit("close-signature", this.typedSignatureName);
      this.$emit("signature-data-canvas", this.signatureDataCanvas);
      console.log(this.signatureDataCanvas, "data");
      this.modal_active = false;
    },
    clearSignatureCanvas(){
      const canvas = document.getElementById("signatureCanvas" + this.unique);
      this.ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.duplicateSignatureDataCanvas = null;
    },
    emitSignature() {
      this.modal_active = false;

      this.$emit("close-signature", this.typedSignatureName);
      this.$emit("emit-signature", this.typedSignatureName);
      this.$emit("emit-signature-font", this.typedSignatureFont);
    },
    emitSignatureFont() {
      this.$emit("emit-signature-font", this.typedSignatureName);
    },
    startDrawing(event) {
      this.isDrawing = true;
      const canvas = document.getElementById("signatureCanvas" + this.unique);
      this.ctx = canvas.getContext("2d");
      const x = event.clientX - canvas.getBoundingClientRect().left;
      const y = event.clientY - canvas.getBoundingClientRect().top;
      this.ctx.beginPath();
      this.ctx.moveTo(x, y);
    },
    stopDrawing() {
      this.isDrawing = false;
      this.ctx.closePath();
    },
    draw(event) {
      if (!this.isDrawing) return;
      const canvas = document.getElementById("signatureCanvas" + this.unique);
      const x = event.clientX - canvas.getBoundingClientRect().left;
      const y = event.clientY - canvas.getBoundingClientRect().top;
      this.ctx.lineTo(x, y);
      this.ctx.stroke();
    },
    switchSignature(val) {
      // switch case to identify what type user have clicked
      switch (val) {
        case "draw":
          this.isDrawSignature = true;
          this.isTypeSignature = false;
          this.isUploadSignature = false;
          this.isSavedSignature = false;
          break;
        case "type":
          this.isDrawSignature = false;
          this.isTypeSignature = true;
          this.isUploadSignature = false;
          this.isSavedSignature = false;
          break;
        case "upload":
          this.isUploadSignature = true;
          this.isDrawSignature = false;
          this.isTypeSignature = false;
          this.isSavedSignature = false;
          break;
        case "saved":
          (this.isDrawSignature = false),
            (this.isTypeSignature = false),
            (this.isUploadSignature = false),
            (this.isSavedSignature = true);
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.signature-pad-heading {
  margin-bottom: 12px;
  // width: 418px;
  height: 36px;
  display: grid;
  border-radius: 8px;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 1.5fr;
  border: 1px solid #d4d4d4;
  span {
    cursor: pointer;
    height: 100%;
    display: flex;
    justify-content: center;
    border-right: 1px solid #d4d4d4;
    align-items: center;
  }
  span:last-child {
    border-right: none;
  }
}
.overwrite-fileupload-height{
  .main-content-body-upload .upload-panel {
height: 260px;
  }
}
</style>
